jQuery.trumbowyg.langs['es-CL'] = {
  viewHTML: 'Ver HTML',

  formatting: 'Formato',
  p: 'Párrafo',
  blockquote: 'Cita',
  code: 'Código',
  header: 'Título',

  bold: 'Negrita',
  italic: 'Itálica',
  strikethrough: 'Tachado',
  underline: 'Subrayado',

  strong: 'Fuere',
  em: 'Énfasis',
  del: 'Borrar',

  unorderedList: 'Lista Desordenada',
  orderedList: 'Lista Ordenada',

  insertImage: 'Insertar una imagen',
  insertVideo: 'Insertar un video',
  link: 'Vínculo',
  createLink: 'Insertar un vínculo',
  unlink: 'Suprimir un vínculo',

  justifyLeft: 'Alinear a la Izquierda',
  justifyCenter: 'Centrar',
  justifyRight: 'Alinear a la Derecha',
  justifyFull: 'Justificado',

  horizontalRule: 'Insertar separado Horizontal',

  fullscreen: 'Pantalla Completa',

  close: 'Cerrar',

  submit: 'Enviar',
  reset: 'Cancelar',

  required: 'Obligatorio',
  description: 'Descripción',
  title: 'Título',
  text: 'Texto'
};